export function userLogin(state=null,action) {
    switch (action.type) {
        case 'USER_LOGIN_STATUS':
            return state
        default:
            return state;
    }
}